'use strict';

import 'angular';


export default function($sce) {
	'ngInject';

	return {
		require: '^actionBoxOptionGroup',
		transclude: true,
		link: postLink,
	}

	function postLink(scope, element, attrs, $optionGroup, transclude) {
		var nodes = transclude(scope, function(clone, scope) {
			element.append(clone);
		}).detach();
		$optionGroup.addOption({
			name: attrs.name,
			icon: attrs.icon,
			description: attrs.description,
			body: nodes,
		});
	}
}
